import { llmApi, ragApi, agentApi } from '../api';

interface ChatServiceParams {
    input: string;
    temperature: number;
    maxTokens: number;
    model: string;
    topP: number;
    sessionId: string;
    mode: 'llm' | 'rag' | 'agent' | 'test';
}

export const sendChatMessage = async (params: ChatServiceParams, token: string) => {
    if (params.mode === 'test') {
        throw new Error('テストモードはsendChatMessageではサポートされていません。');
    }
    
    let apiFunction;
    if (params.mode === 'rag') {
        apiFunction = ragApi;
    } else if (params.mode === 'agent') {
        apiFunction = agentApi;
    } else {
        apiFunction = llmApi;
    }
    
    const result = await apiFunction({
        input: params.input,
        temperature: params.temperature,
        max_tokens: params.maxTokens,
        bedrock_model_id: params.model,
        top_p: params.topP,
        sessionId: params.sessionId
    }, token);

    if (result && result.answer) {
        return result.answer;
    } else {
        throw new Error('Unexpected response format');
    }
};